//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

// #region Imports
import { EthAddr, TxHash } from '@shared/SchemaTypes'
import { Contract, Signer } from 'ethers'

import { ActivityEnum, RoleEnum } from '@shared/Enums'

import { logOT } from '@shared/loggingShared'

import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'

import { assertRole, dispatchError, OtStoreState } from '@react/redux/store'

import { APR, otAssert } from '@shared/conversions'

import { PoolAbi } from '@shared/Abis'
import { txUUID, wsServerActionPoolTX, wsServerActionPoolTXRequest } from '@shared/WsServerActions'
import { poolActions } from '@react/redux/poolSlice'

export const rolloverAndFinalizeAprTx =
  (props: {
    poolAddr: EthAddr
    loanAddr: EthAddr
    apr: APR
  }): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, getState): Promise<void> => {
    const activity = ActivityEnum.POOL_ROLLOVER_FINALIZE

    try {
      logOT.debug('rolloverFinalizeSaga 1')
      const { poolAddr, loanAddr, apr } = props

      const { webSocket, userConnection } = getState().chainState
      const { chainConfigurationName } = getState().chainState.chainConfiguration
      otAssert(userConnection, 'userConnection is not defined')
      const { roleEnum, signer } = userConnection
      assertRole(roleEnum, RoleEnum.BORROWER)
      await rolloverAndFinalizeApr(webSocket, signer as Signer, poolAddr, apr, chainConfigurationName)

      dispatch(poolActions.rolloverFinalizeSuccess({ poolAddr, loanAddr }))
    } catch (e: any) {
      await dispatchError(dispatch, e, activity, 4004)
    }
  }

export const rolloverAndFinalizeApr = async (
  webSocket: WebSocket | undefined,
  borrowerSigner: Signer,
  poolAddr: EthAddr,
  apr: APR,
  chainConfigurationName: string
): Promise<void> => {
  logOT.debug('initiateRollover', poolAddr, apr)
  const uuid = txUUID()
  webSocket?.send(
    wsServerActionPoolTXRequest(ActivityEnum.POOL_ROLLOVER_FINALIZE, poolAddr, uuid, chainConfigurationName)
  )

  const poolContract = new Contract(poolAddr, PoolAbi, borrowerSigner)
  const tx2 = await poolContract.rolloverAndFinalizeApr(apr)

  webSocket?.send(
    wsServerActionPoolTX(
      ActivityEnum.POOL_ROLLOVER_FINALIZE,
      poolAddr,
      uuid,
      tx2.hash as TxHash,
      chainConfigurationName
    )
  )
  const approveReceipt = await tx2.wait(1)
  logOT.debug('{ approveReceipt', approveReceipt)
}
